import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    connections: [],
    loaded: false
  }
};
const ConnectionsSlice = createSlice({
  name: "connections",
  initialState,
  reducers: {
    loadConnections: (state, action) => {
      console.log("loading");
      state.value = {
        connections: action.payload,
        loaded: true
      };
    }
  }
});
export const { loadConnections } = ConnectionsSlice.actions;
export default ConnectionsSlice.reducer;
